import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const Wrapper = styled(Box)(`
  min-height: calc(100vh - 300px);
`)

export const WidgetOuterWrapper = styled(Box)( props => `
  width: 100%;
  position: relative;
  display: grid;
  grid-auto-flow: dense; /* auto-place spanned items */
`)

export const WidgetInnerWrapper = styled(Box)( props => `
  width: 100%;
  position: relative;
  display: grid;
  grid-auto-flow: dense; /* auto-place spanned items */
`)
